
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 100 125"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M49.992 16.244c14.27 0 28.541.009 42.811-.013 1.486-.002 2.904 1.142 3.2 2.523.043.2.066.407.066.611.003 18.592.003 37.184.002 55.776 0 1.488-1.203 2.957-2.807 3.115-.349.034-.701.062-1.051.062-28.3.003-56.601.001-84.901.005-1.631 0-3.116-1.189-3.321-2.793-.025-.193-.059-.388-.059-.581-.004-18.477-.006-36.954-.001-55.432 0-1.656 1.144-2.964 2.78-3.269.101-.019.208-.005.313-.005l42.968.001zM50 19.125H7.312c-.291.003-.481.178-.501.467-.006.083-.001.167-.001.25v54.872c0 .599.125.725.725.725h85.001c.514 0 .655-.142.655-.658V19.784c0-.583-.076-.659-.659-.659H50zM50.013 80.763c10.815 0 21.63-.001 32.445.003.636 0 1.151.272 1.498.819.424.671.009 1.73-.805 1.986-.356.112-.741.19-1.112.19-21.359.009-42.717.008-64.076.005-.431 0-.851-.066-1.249-.268-.63-.318-.853-.895-.812-1.34.058-.623.41-1.064 1.01-1.263a2.53 2.53 0 01.781-.128c10.774-.005 21.547-.004 32.32-.004z"}}),_c('path',{attrs:{"d":"M42.045 28.938c.239.202.459.38.67.568.795.708 1.585 1.421 2.381 2.128.872.774 1.749 1.543 2.625 2.313.86.757 1.722 1.512 2.582 2.268.705.62 1.409 1.243 2.114 1.864l3.138 2.762 2.626 2.313c1.046.921 2.09 1.843 3.138 2.761.536.469 1.077.931 1.641 1.417-.528.48-1.025.942-1.533 1.393-.416.369-.847.72-1.267 1.085-.833.724-1.663 1.452-2.493 2.18-.559.491-1.112.988-1.67 1.479-.844.743-1.693 1.481-2.536 2.226-.596.527-1.184 1.064-1.781 1.589-.798.701-1.603 1.395-2.402 2.093-.373.326-.741.658-1.114.986-.845.742-1.693 1.481-2.536 2.226-.596.527-1.185 1.062-1.781 1.589-.586.519-1.177 1.034-1.802 1.583V28.938z"}})])
          )
        }
      }
    